import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'ConnectionHubDetailsRouteMode',
  components: {
    Paginate,
    BasicSelect,
    VueElementLoading,
    DatePicker,
    Multiselect
  },
  props: [],
  data() {
    return {
      ConnectionHubDetails: [],
      hubzoneLoading: '',
      HubZoneListData: [],
      hubzonelist: [],
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubzone: '',
      connectiontype: '',
      HubNameData: [],
      hubLoading: '',
      sourcehubnamelist: [],
      sourcehubnameitem: {
        id: '',
        text: ''
      },
      sourcehubname: '',
      connectionLoading: '',
      ConnectionNameData: [],
      connectionlist: [],
      connectionitem: {
        id: '',
        text: ''
      },
      destinationhubnamelist: [],
      destinationhubnameitem: {
        id: '',
        text: ''
      },
      destinationhubname: '',
      connection: '',
      isConnectionError: 0,
      ConnectionError: '',
      routemode: '',
      startdate: '',
      enddate: '',
      modaldata: '',
      isLoading: false,
      istemporary: false,
      addmodalshow: false,
      modalShow: false,
      addmodalShowPattern: false,
      modalShowPattern: false,
      //for Search filter
      hubzonefltlist: [],
      hubzonefltitem: {
        id: '',
        text: ''
      },
      searchhubzone: '',
      sourcehubnamefltlist: [],
      sourcehubnamefltitem: {
        id: '',
        text: ''
      },
      searchsourcehubname: '',
      searchdestinationhubname: '',
      connectionfltlist: [],
      destinationhubnamefltlist: [],
      connectionfltitem: {
        id: '',
        text: ''
      },
      destinationfltitem: {
        id: '',
        text: ''
      },
      searchconnection: '',
      isfltConnectionError: 0,
      fltConnectionError: '',
      flthubLoading: '',
      fltconnectionLoading: '',
      IsActive: false,
      hubzoneError: '',
      sourcehubError: '',
      destinationhubError: '',
      connectionnameError: '',
      userData:[]
    }
  },
  computed: {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.getHubZone();
    this.getDestinationHubName();
  },
  methods: {
    //to get selected hub zone name
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      if (this.hubzoneitem.text != undefined) {
        this.getHubName()
      }
      this.sourcehubnameitem = {
        id: '',
        text: ''
      }
      this.connectionitem = {
        id: '',
        text: ''
      }
      this.sourcehubname = ''
      this.connection = ''
      this.isConnectionError = 0;
      this.ConnectionError = ''
      this.sourcehubnamelist = []
      //this.$validator.reset()
    },
    //to get selected hub name
    selectHubName(sourcehubnameitem) {
      this.sourcehubnameitem = sourcehubnameitem
      this.sourcehubname = this.sourcehubnameitem.text
      this.isConnectionError = 0;
      this.ConnectionError = ''
      this.connection = ''
      //this.$validator.reset()
      this.connectionitem = {
        id: '',
        text: ''
      }
      this.connectionlist = []
      this.getConnectionName()
    },
    //to get selected connection name
    selectConnection(connectionitem) {
      this.connectionitem = connectionitem
      this.connection = this.connectionitem.fullroute
      this.isConnectionError = 0;
      this.ConnectionError = ''
    },
    selectDestHubName(destinationhubnameitem) {
      this.destinationhubnameitem = destinationhubnameitem
      this.destinationhubname = this.destinationhubnameitem.text
    },
    SelectDestinationHubName(destinationfltitem) {
      this.destinationfltitem = destinationfltitem
      this.searchdestinationhubname = this.destinationfltitem.id
      if (this.searchdestinationhubname == '' || this.searchdestinationhubname == undefined) {
        this.destinationhubError = 'The Destination Hub field is required.';
      } else {
        this.destinationhubError = '';
      }
    },
    //to get hubzone list
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        // hubName: this.hubzoneitem.id,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          this.HubZoneListData = result.data.ResponseData;
          for (i = 0; i < this.HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: this.HubZoneListData[i].hubzoneid,
              text: this.HubZoneListData[i].hubzonename
            })
          }
        }, error => {
          console.error(error)
        })
    },
    //to get hubname list
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubzoneitem.id,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.HubNameData = result.data.ResponseData
          for (i = 0; i < this.HubNameData.length; i++) {
            this.sourcehubnamelist.push({
              id: this.HubNameData[i].HubID,
              text: this.HubNameData[i].HubName + ' (' + this.HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
    },
    getDestinationHubName() {
      this.destinationhubnamelist = []
      this.destinationhubnamefltlist = []
      this.destinationfltitem = {
        id: '',
        text: ''
      }
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = {}
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          for (var i = 0; i < HubNameData.length; i++) {
            this.destinationhubnamelist.push({
              id: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.destinationhubnamefltlist.push({
              id: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
    },
    //to get hubname list for search filter
    getHubNameforFilter() {
      this.flthubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubzonefltitem.id,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.flthubLoading = ''
          this.HubNameData = result.data.ResponseData
          for (i = 0; i < this.HubNameData.length; i++) {
            this.sourcehubnamefltlist.push({
              id: this.HubNameData[i].HubID,
              text: this.HubNameData[i].HubName + ' (' + this.HubNameData[i].HubID + ')'
            })
          }
        }, error => {
          console.error(error)
        })
    },
    //to get connection name list
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      if (this.sourcehubnameitem.id == '' || this.connectiontype == '' || this.sourcehubnameitem.id == undefined || this.connectiontype == undefined) {
        return false;
      } else {
        var i = 0;
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = {
          source: parseInt(this.sourcehubnameitem.id),
          type: parseInt(this.connectiontype)
        }
        axios({
            'method': 'POST',
            'url': apiUrl.api_url_hubops + 'getroutemaster',
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.connectionLoading = ''
            if (result.data.ResultCode == 100) {
              this.ConnectionNameData = result.data.ResponseData
              this.isConnectionError = 0;
              this.ConnectionError = ''
              for (i = 0; i < this.ConnectionNameData.length; i++) {
                this.connectionlist.push({
                  id: this.ConnectionNameData[i].ConnectionID,
                  text: this.ConnectionNameData[i].ConnectionName,
                  fullroute: this.ConnectionNameData[i].FullConnectionName
                })
              }
            } else {
              this.isConnectionError = 1;
              this.ConnectionError = 'No Connection Found'
            }
          }, error => {
            //this.$alertify.error('error in connection api')
            this.connectionLoading = ''
            this.isConnectionError = 0;
            this.ConnectionError = ''
            this.$alert('error in connection api', "", "error");
            console.error(error)
          })
      }
    },
    //to get connection name list for search filter
    getConnectionNameforFilter() {
      this.fltconnectionLoading = 'Loading Connection...'
      if (this.sourcehubnamefltitem.id == '' || this.sourcehubnamefltitem.id == undefined) {
        return false;
      } else {
        var i = 0;
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = {
          source: parseInt(this.sourcehubnamefltitem.id)
        }
        axios({
            'method': 'POST',
            'url': apiUrl.api_url_hubops + 'getroutemaster',
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.fltconnectionLoading = ''
            if (result.data.ResultCode == 100) {
              this.ConnectionNameData = result.data.ResponseData
              this.isfltConnectionError = 0;
              this.fltConnectionError = ''
              for (i = 0; i < this.ConnectionNameData.length; i++) {
                this.connectionfltlist.push({
                  id: this.ConnectionNameData[i].ConnectionID,
                  text: this.ConnectionNameData[i].ConnectionName
                })
              }
            } else {
              this.isfltConnectionError = 1;
              this.fltConnectionError = 'No Connection Found'
            }
          }, error => {
            //this.$alertify.error('error in connection api')
						this.fltconnectionLoading = ''
						this.isfltConnectionError = 0;
						this.fltConnectionError = ''
            this.$alert('error in connection api', "", "error");
            console.error(error)
          })
      }
    },
    //to get selected hub zone in search filter
    SearchHubZoneName(hubzonefltitem) {
      this.hubzonefltitem = hubzonefltitem
      this.searchhubzone = this.hubzonefltitem.id
      this.sourcehubnamefltlist = []
      this.ConnectionHubDetails = []
      this.sourcehubnamefltitem = {
        id: '',
        text: ''
      }
      this.connectionfltitem = {
        id: '',
        text: ''
      }
      if (this.searchhubzone == '' || this.searchhubzone == undefined) {
        this.hubzoneError = 'The Hub Zone Name field is required.';
      } else {
        this.hubzoneError = '';
      }
      if (this.hubzonefltitem.text != undefined) {
        this.getHubNameforFilter()
      }
    },
    //to get selected hub name in search filter
    SearchHubName(sourcehubnamefltitem) {
      this.sourcehubnamefltitem = sourcehubnamefltitem
      this.searchsourcehubname = this.sourcehubnamefltitem.id
      this.connectionfltitem = {
        id: '',
        text: ''
      }
      this.connectionfltlist = []
      this.ConnectionHubDetails = []
      if (this.searchsourcehubname == '' || this.searchsourcehubname == undefined) {
        this.sourcehubError = 'The Source Hub field is required.';
      } else {
        this.sourcehubError = '';
        this.getConnectionNameforFilter()
      }
    },
    //to get selected connection name in search filter
    searchConnection(connectionfltitem) {
      this.connectionfltitem = connectionfltitem
      this.searchconnection = this.connectionfltitem.id
      if (this.searchconnection == '' || this.searchconnection == undefined) {
        this.connectionnameError = 'The Connection field is required.';
      } else {
        this.connectionnameError = '';
      }
    },
    //reset search filter's field
    // resetflt(){
    //   this.hubzonefltitem={id:'',text:''}
    //   this.sourcehubnamefltitem={id:'',text:''}
    //   this.connectionfltitem={id:'',text:''}
    //   this.ConnectionHubDetails=[]
    //   this.getConnectionHubDetailsList()
    // },
    chkFields() {
      var isErr = 0;
      if (this.searchhubzone == '' || this.searchhubzone == undefined) {
        this.hubzoneError = 'The Hub Zone Name field is required.';
        isErr = 1;
      } else {
        this.hubzoneError = '';
      }
      if (this.searchsourcehubname == '' || this.searchsourcehubname == undefined) {
        this.sourcehubError = 'The Source Hub field is required.';
        isErr = 1;
      } else {
        this.sourcehubError = '';
      }
      if (this.searchdestinationhubname == '' || this.searchdestinationhubname == undefined) {
        this.destinationhubError = 'The Destination Hub field is required.';
        isErr = 1;
      } else {
        this.destinationhubError = '';
      }
      if (this.searchconnection == '' || this.searchconnection == undefined) {
        this.connectionnameError = 'The Connection field is required.';
        isErr = 1;
      } else {
        this.connectionnameError = '';
      }
      if (isErr == 1) {
        return false;
      }
    },
    // to get connection hub details route mode list
    getConnectionHubDetailsList() {
      if (this.chkFields() == false) {
        return false;
      }
      this.isLoading = true;
      this.ConnectionHubDetails = []
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchAllocatedHubConnectionToRouteMode?hubId=' + this.destinationfltitem.id + '&connectionId=' + this.connectionfltitem.id + '&isActive=' + this.IsActive,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.ConnectionHubDetails = result.data.ResponseData;
            let totalRows = result.data.ResponseData.length
            if (totalRows < 10) {
              this.pageCountrule = 1
            } else {
              this.pageCountrule = Math.ceil(totalRows / 10);
            }
          } else {
            //  this.$alertify.error("No record found")
            this.$alert("No record found", "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    //add connection hub details
    saveConnectionHubDetails() {
      if (this.istemporary == true) {
        if (this.startdate == '') {
          return false
        } else if (this.enddate == '') {
          return false
        }
      }
      this.input = {
        "hubId": this.destinationhubnameitem.id,
        "destinationHubName": this.destinationhubnameitem.text,
        "connectionId": this.connectionitem.id,
        "connectionName": this.connectionitem.text,
        "routeMode": this.routemode,
        "isTemporary": this.istemporary,
        "startDate": this.startdate,
        "endDate": this.enddate,
        "createdBy": this.createdBy,
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'allocateHubToRouteMode',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(this.userData[0], "ConnectionHubDetailsRouteMode", this.$route.path , this.input);
            this.resetForm()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //to clear form
    resetForm() {
      this.hubzoneitem = {
        id: '',
        text: ''
      }
      this.connectiontype = ''
      this.routemode = ''
      this.sourcehubnameitem = {
        id: '',
        text: ''
      }
      this.connectionitem = {
        id: '',
        text: ''
      }
      this.destinationhubnameitem = {
        id: '',
        text: ''
      }
      this.istemporary = false
      this.hubZone = ''
      this.hubzone = ''
      this.sourcehubname = ''
      this.hubname = ''
      this.connection = ''
      this.startdate = ''
      this.enddate = ''
      this.isConnectionError = 0;
      this.ConnectionError = ''
      this.$validator.reset()
    },
    //opens active/inactive modal
    openStatusModal(data) {
      this.modaldata = data
      this.modalShow = true
    },
    //close active/inactive modal
    closeStatusModal() {
      this.modalShow = false
    },
    //for active/inactive modal
    changeStatus() {
      var newactStatus = this.modaldata.isactive ? false : true
      this.input = {
        "connectionId": this.modaldata.connectionid,
        "hubId": this.modaldata.hubid,
        "createdBy": this.createdBy,
        "routeMode": this.modaldata.routemode,
        "isActive": newactStatus
      }
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'deallocateHubConnectionFromRouteMode',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(this.userData[0], "ConnectionHubDetailsRouteMode", this.$route.path , this.input);
            this.getConnectionHubDetailsList()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage, "", "error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.saveConnectionHubDetails();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ConnectionHubDetailsRouteMode/ConnectionHubDetailsRouteMode.component.js